export type DetectedOs = 'ios' | 'android' | 'windows' | 'macos' | 'linux' | 'other';

// Answers "which store can this visitor install from?" as well as feeding the
// analytics `os` super property, so both read the same sniff.
export const detectOs = (): DetectedOs => {
  const ua = navigator.userAgent.toLowerCase();
  // iPadOS Safari reports itself as a Mac; the touch check separates them.
  const isIpadOs = ua.includes('mac') && navigator.maxTouchPoints > 1;
  if (/iphone|ipad|ipod/.test(ua) || isIpadOs) return 'ios';
  if (ua.includes('android')) return 'android';
  if (ua.includes('windows')) return 'windows';
  if (ua.includes('mac')) return 'macos';
  if (ua.includes('linux')) return 'linux';
  return 'other';
};

export type InAppBrowser = 'instagram' | 'facebook';

// Meta's in-app browsers, which Mixpanel's $browser can't tell apart from the
// real ones: Instagram on iOS reads as "Mobile Safari", Facebook on Android as
// "Chrome". Instagram is checked first since its UA can also carry FB tokens.
export const detectInAppBrowser = (ua: string = navigator.userAgent): InAppBrowser | null => {
  if (/\bInstagram\b/.test(ua)) return 'instagram';
  if (/\bFBAN\/|\bFBAV\/|\bFB_IAB\//.test(ua)) return 'facebook';
  return null;
};
